import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccountToggleHeaderComponent } from './components/account-toggle-header/account-toggle-header.component';
import { AddDependentFormComponent } from './components/add-dependent-form/add-dependent-form.component';
import { GlobalFooterComponent } from './components/global-footer/global-footer.component';
import { LeftNavBarComponent } from './components/left-nav-bar/left-nav-bar.component';
import { ModalSlideComponent } from './components/modal-slide.component';
import { MotifPaginationComponent } from './components/motif-pagination/motif-pagination.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { SaeResetPasswordComponent } from './components/sae-reset-password/sae-reset-password.component';
import { SaeResetPasswordService } from './components/sae-reset-password/sae-reset-password.service';
import { SearchHeaderComponent } from './components/search-header/search-header.component';
import { SecureGlobalHeaderComponent } from './components/secure-global-header/secure-global-header.component';
import { UniversityHeaderComponent } from './components/university-header/university-header.component';
import { AuthGuardService } from './services/auth-guard.service';
import { AuthService } from './services/auth.service';
import { DownloadFileUtil } from './services/downloadFile-utility';
// import { DetailsService } from '../pages/secure/account/details/details.service';
// import { LoginInfoService } from '../pages/secure/account/login-info/login-info.service';
import { HttpClientService } from './services/http-client-service';
import { PublicGuardService } from './services/public-guard.service';
import { SharedService } from './services/shared.service';
import { TokenService } from './services/token.service';
import { UtilityService } from './services/utility.service';
import { WcsApiService } from './services/wcs-api-service';
import { SafeHtmlPipe } from './pipes/safeHtml';

@NgModule({
  declarations: [
    PageHeaderComponent,
    SecureGlobalHeaderComponent,
    GlobalFooterComponent,
    SaeResetPasswordComponent,
    ModalSlideComponent,
    UniversityHeaderComponent,
    SearchHeaderComponent,
    LeftNavBarComponent,
    AccountToggleHeaderComponent,
    MotifPaginationComponent,
    AddDependentFormComponent,
    SafeHtmlPipe
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  providers: [
    AuthService,
    TokenService,
    AuthGuardService,
    HttpClientService,
    WcsApiService,
    PublicGuardService,
    UtilityService,
    SaeResetPasswordService,
    SharedService,
    DownloadFileUtil
    // DetailsService,
    // LoginInfoService,
  ],
  exports: [
    PageHeaderComponent,
    SecureGlobalHeaderComponent,
    GlobalFooterComponent,
    SaeResetPasswordComponent,
    ModalSlideComponent,
    UniversityHeaderComponent,
    SearchHeaderComponent,
    LeftNavBarComponent,
    AccountToggleHeaderComponent,
    MotifPaginationComponent,
    AddDependentFormComponent,
    SafeHtmlPipe
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [
    PageHeaderComponent,
    SecureGlobalHeaderComponent,
    GlobalFooterComponent,
    SaeResetPasswordComponent,
    ModalSlideComponent,
    UniversityHeaderComponent,
    SearchHeaderComponent,
    LeftNavBarComponent
  ],
})
export class CustomCommonModule { }
